<!-- src/components/The33AppHeader.vue -->
<template>
  <div class="header-container">
    <header class="section app-header text-center animCont">
      <!-- Cabeçalho principal -->
      <div>
        <div class="topHeader">
          <h1 class="boldFont ginourmousOnDesktop">
            The <span class="serif lowerOnDesktop">33&nbsp;App</span>
          </h1>

          <!-- Legenda (canto superior esquerdo) -->
          <p
            class="topHeaderNote animate text-left smallFontSize fadeInLeft noMarginBottom"
          >
            This simulated experience invites you in the inter-dimensional
            adventure available at the 33&nbsp;app. This app will function as a
            gateway for any users interested in going through a real-life
            initiation with this brand's consciousness, experiencing something
            unique in the context of storytelling and cinema.
          </p>
        </div>

        <!-- Texto centrado sobre o triângulo invertido -->
        <div class="triangleTextCont">
          <div class="triangleText row fullWidth alignCentreRow alignTopRow">
            <div class="theApp animate fadeInRight">
              <h1>The&nbsp;app</h1>
            </div>

            <div class="isAPortal animate fadeInRight">
              <h1>is<span class="serif textGold"> a&nbsp;portal</span></h1>
            </div>
          </div>

          <!-- Triângulo invertido -->
          <img
            :src="triangleImage"
            alt="Símbolo triângulo invertido"
            class="marginTopBottom trianguleImg"
          />
        </div>

        <!-- Símbolo vectorial em vez da fotografia -->
        <div class="column alignCentreColumn symbol-imageContCont">
          <div class="symbol-image-container">
            <div class="rgb-displacement-container">
              <!-- Using different colored versions of the symbol image -->
              <img
                :src="symbolPurpleImage"
                alt="Symbol"
                class="symbol-image-duplicate red-duplicate marginTopBottom fadeInRight animate"
              />
              <img
                :src="symbolGoldImage"
                alt="Symbol"
                class="symbol-image-duplicate green-duplicate marginTopBottom fadeInRight animate"
              />
              <img
                :src="symbolTealImage"
                alt="Symbol"
                class="symbol-image-duplicate blue-duplicate marginTopBottom fadeInRight animate"
              />
              <img
                :src="symbolWhiteImage"
                alt="Symbol"
                class="symbol-image hidden marginTopBottom"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Legenda (canto inferior direito) -->
      <div class="topHeaderBottomNoteCont fullWidth">
        <p
          class="topHeaderBottomNote animate text-right smallFontSize fadeInLeft"
        >
          The experience provided within this app was channeled by Patricia
          directly from Source and offers the audience the possibility to enter
          a transformative journey, where you will evolve along with the
          consciousness guiding this brand. The app is an initiatory experience
          that transcends the limits of screen and fiction, providing you with
          an opportunity to receive downloads, codes of light and transmissions
          that will assist you in your own ladder of evolution. We'll meet at
          the threshold.
        </p>
      </div>
    </header>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "The33AppHeader",
  setup() {
    // Triângulo (o mesmo ficheiro usado noutros componentes; roda-se 180 ° no CSS)
    const triangleImage = ref(
      require("@/assets/images/triangle.png").default
        ? require("@/assets/images/triangle.png").default
        : require("@/assets/images/triangle.png")
    );

    // Símbolo vectorial que substitui a fotografia
    const symbolPurpleImage = ref(
      require("@/assets/images/TheApp/isometric_structure_purple.png").default
        ? require("@/assets/images/TheApp/isometric_structure_purple.png")
            .default
        : require("@/assets/images/TheApp/isometric_structure_purple.png")
    );

    const symbolGoldImage = ref(
      require("@/assets/images/TheApp/isometric_structure_gold.png").default
        ? require("@/assets/images/TheApp/isometric_structure_gold.png").default
        : require("@/assets/images/TheApp/isometric_structure_gold.png")
    );

    const symbolTealImage = ref(
      require("@/assets/images/TheApp/isometric_structure_teal.png").default
        ? require("@/assets/images/TheApp/isometric_structure_teal.png").default
        : require("@/assets/images/TheApp/isometric_structure_teal.png")
    );

    const symbolWhiteImage = ref(
      require("@/assets/images/TheApp/isometric_structure_white.png").default
        ? require("@/assets/images/TheApp/isometric_structure_white.png")
            .default
        : require("@/assets/images/TheApp/isometric_structure_white.png")
    );

    // Setup displacement effect
    onMounted(() => {
      // Add longer delay to ensure drawer is fully rendered
      setTimeout(() => {
        setupRGBDisplacementEffect();
      }, 100);
    });

    const setupRGBDisplacementEffect = () => {
      const container = document.querySelector(
        ".app-header .rgb-displacement-container"
      );
      if (!container) return;

      // Find the drawer container to handle transform offsets
      const drawerContainer = document.querySelector(".drawer-container");

      // Debug: Check container position
      const rect = container.getBoundingClientRect();

      // Get the duplicate image elements
      const redDuplicate = container.querySelector(".red-duplicate");
      const greenDuplicate = container.querySelector(".green-duplicate");
      const blueDuplicate = container.querySelector(".blue-duplicate");

      let lastMouseX = 0;
      let lastMouseY = 0;
      let mouseSpeedX = 0;
      let mouseSpeedY = 0;
      let isActive = false;
      let animationFrame = null;
      let decayFactor = 0.95; // Controls how quickly the movement slows down
      let isHovering = false; // Track if mouse is hovering over container

      // Set all duplicates to be in the exact same position initially
      function resetAllToCenter() {
        if (redDuplicate) {
          redDuplicate.style.transform = "translate(0px, 0px)";
          redDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          redDuplicate.style.opacity = "0.4";
        }
        if (greenDuplicate) {
          greenDuplicate.style.transform = "translate(0px, 0px)";
          greenDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          greenDuplicate.style.opacity = "0.4";
        }
        if (blueDuplicate) {
          blueDuplicate.style.transform = "translate(0px, 0px)";
          blueDuplicate.style.transition =
            "transform 0.3s ease-out, opacity 0.3s ease";
          blueDuplicate.style.opacity = "0.4";
        }
      }

      // Set initial positions to center with explicit pixel values
      resetAllToCenter();

      // Track mouse movement for desktop with smoother transitions
      container.addEventListener("mouseenter", () => {
        isHovering = true;
      });

      container.addEventListener("mouseleave", () => {
        isHovering = false;
        isActive = false;

        // Cancel any ongoing animations
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }

        // Reset all duplicates to center when mouse leaves
        resetAllToCenter();
      });

      container.addEventListener("mousemove", (e) => {
        if (!isHovering) return;

        // Get fresh rect to account for any transforms
        const rect = container.getBoundingClientRect();

        // Calculate mouse position relative to the container
        // Account for any transforms on parent elements
        let mouseX = e.clientX - rect.left;
        let mouseY = e.clientY - rect.top;

        // If inside drawer, we need to account for scroll position
        if (drawerContainer) {
          const scrollTop = drawerContainer.scrollTop || 0;
          mouseY = mouseY + scrollTop;
        }

        // Calculate mouse speed
        mouseSpeedX = mouseX - lastMouseX;
        mouseSpeedY = mouseY - lastMouseY;

        lastMouseX = mouseX;
        lastMouseY = mouseY;

        // Use lower threshold for more responsive movement
        if (Math.abs(mouseSpeedX) > 2 || Math.abs(mouseSpeedY) > 2) {
          isActive = true;
          // Cancel any ongoing animations
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          updateDisplacement(mouseSpeedX, mouseSpeedY);
        }
      });

      // Handle touch events for mobile
      container.addEventListener("touchstart", () => {
        isHovering = true;
      });

      container.addEventListener("touchend", () => {
        isHovering = false;
        isActive = false;

        // Cancel any ongoing animations
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }

        // Reset all duplicates to center when touch ends
        resetAllToCenter();
      });

      container.addEventListener("touchmove", (e) => {
        if (!isHovering || e.touches.length === 0) return;

        const rect = container.getBoundingClientRect();
        const touchX = e.touches[0].clientX - rect.left;
        const touchY = e.touches[0].clientY - rect.top;

        // Calculate touch speed
        mouseSpeedX = touchX - lastMouseX;
        mouseSpeedY = touchY - lastMouseY;

        lastMouseX = touchX;
        lastMouseY = touchY;

        // Use lower threshold for more responsive movement
        if (Math.abs(mouseSpeedX) > 1 || Math.abs(mouseSpeedY) > 1) {
          isActive = true;
          // Cancel any ongoing animations
          if (animationFrame) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
          }
          updateDisplacement(mouseSpeedX, mouseSpeedY);
        }
      });

      // Function to update displacement based on mouse/touch movement
      function updateDisplacement(speedX, speedY) {
        if (!isActive || !isHovering) return;

        const displacementX = Math.min(Math.max(speedX * 1.2, -40), 40);
        const displacementY = Math.min(Math.max(speedY * 1.2, -40), 40);

        // Apply different displacements with smoother motion
        if (redDuplicate) {
          const redX = displacementX * 1.4;
          const redY = displacementY * 0.9;
          redDuplicate.style.transform = `translate(${redX}px, ${redY}px)`;
          redDuplicate.style.opacity = "0.8";
          redDuplicate.style.transition =
            "transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        if (greenDuplicate) {
          const greenX = displacementX * -1.1;
          const greenY = displacementY * 1.3;
          greenDuplicate.style.transform = `translate(${greenX}px, ${greenY}px)`;
          greenDuplicate.style.opacity = "0.8";
          greenDuplicate.style.transition =
            "transform 0.25s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        if (blueDuplicate) {
          const blueX = displacementX * 0.9;
          const blueY = displacementY * -1.2;
          blueDuplicate.style.transform = `translate(${blueX}px, ${blueY}px)`;
          blueDuplicate.style.opacity = "0.8";
          blueDuplicate.style.transition =
            "transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.25s ease";
        }

        // Use a smoother decay factor
        const newSpeedX = speedX * decayFactor;
        const newSpeedY = speedY * decayFactor;

        // Continue animation if still moving significantly
        if (Math.abs(newSpeedX) > 0.4 || Math.abs(newSpeedY) > 0.4) {
          animationFrame = requestAnimationFrame(() =>
            updateDisplacement(newSpeedX, newSpeedY)
          );
        } else {
          isActive = false;
          resetAllToCenter();
        }
      }

      // Set initial opacity for the duplicates
      if (redDuplicate) redDuplicate.style.opacity = "0.4";
      if (greenDuplicate) greenDuplicate.style.opacity = "0.4";
      if (blueDuplicate) blueDuplicate.style.opacity = "0.4";
    };

    return {
      triangleImage,
      symbolPurpleImage,
      symbolGoldImage,
      symbolTealImage,
      symbolWhiteImage,
    };
  },
};
</script>

<style scoped>
/* Estilos base herdados e ajustados */
header {
  max-width: var(--maxWidth);
  display: flex;
  flex-direction: column;
  margin-bottom: var(--largeSpace);
  padding: var(--largeSpace);
  justify-content: space-between;
  color: var(--text-white);
}
.header-container.section {
  display: flex;
  margin: auto;
  flex-direction: column;
  align-items: center;
}

/* Tamanhos grandes no desktop */
.ginourmousOnDesktop {
  font-size: 6.5em;
  margin-bottom: calc(var(--largeSpace) * 1.2);
  transform: translateX(-120px);
}

/* “APP” ligeiramente mais baixo */
.lowerOnDesktop {
  position: absolute;
  transform: translateY(40px);
  white-space: nowrap;
}

/* Legendas topo e fundo */
.topHeaderNote {
  max-width: 50%;
}

.topHeaderBottomNoteCont {
  display: flex;
  justify-content: flex-end;
}
.topHeaderBottomNote {
  max-width: 40%;
}

/* Conteúdo principal do símbolo */
.symbol-imageContCont {
  position: absolute;
  width: 100%;
  transform: translate(-25%, -35%);
}

.symbol-image-container {
  width: 55%;
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

/* RGB Displacement effect */
.rgb-displacement-container {
  position: relative;
  width: 60%;
  max-height: 60vh; /* Match PathHeader container height */
  cursor: pointer;
  overflow: visible;
  pointer-events: auto; /* Ensure container receives events */
  /* Ensure the container establishes its own stacking context */
  transform: translateZ(0);
  will-change: transform;
}

.symbol-image-duplicate {
  position: absolute;
  width: 100%;
  height: auto;
  max-height: 55vh; /* Match PathHeader height */
  display: block;
  object-fit: contain;
  opacity: 1; /* Initial opacity 1 for proper blending */
  transition: transform 0.15s ease-out, opacity 0.2s ease;
  pointer-events: none;
}

.red-duplicate {
  mix-blend-mode: screen;
  z-index: 3;
}

.green-duplicate {
  mix-blend-mode: screen;
  z-index: 2;
}

.blue-duplicate {
  mix-blend-mode: screen;
  z-index: 4;
}

.symbol-image.hidden {
  visibility: hidden;
  display: block;
  height: auto;
  opacity: 0;
}

/* Triângulo invertido */
.trianguleImg {
  max-height: 12vh;
  width: auto;
  object-fit: contain;
  mix-blend-mode: difference;
  opacity: 0.6;
  margin: 0 auto;
  transform: rotate(184deg) scale(1.2) translateX(22px);
}

/* Texto dourado */
.textGold {
  color: var(--gold-colour, #d4af37);
}

/* Ajustes de alinhamento para “a portal” */
.theApp {
  white-space: nowrap;
}
.isAPortal {
  margin-top: calc(var(--hugeFontSize) * 1.2);
  white-space: nowrap;
  margin-left: -100px;
}

/* Tamanhos responsivos */
@media (max-width: 680px) {
  .isAPortal {
    font-size: var(--hugeFontSize);
  }
  .ginourmousOnDesktop {
    font-size: 4.8em;
  }
  .topHeaderBottomNote {
    max-width: 50%;
  }

  .rgb-displacement-container {
    width: 100%;
  }
  .symbol-imageContCont {
    position: absolute;
    transform: translate(-25%, -10%);
  }
  .symbol-image-container {
    width: 50%;
    margin-left: 20%;
  }
  .triangleTextCont {
    width: calc(100% - var(--largeSpace));
    transform: translate(0, 25px);
  }
  .trianguleImg {
    max-height: 9vh;
  }
}
</style>
